export const aiContactData = {
  heading: "Get a free 30-minute consultancy",
  subHeading: " worth $250.",
  contactSections: [
    {
      title: "Skilled Talent Network",
      description: "Our team consists of highly experienced professionals.",
    },
    {
      title: "Swift Turnaround",
      description:
        "We provide fast & efficient solutions despite time constraints.",
    },
    {
      title: "Cost-effective Solutions",
      description:
        "We deliver high-quality services that maximize your budget’s potential.",
    },
    {
      title: "Innovation-Driven Development",
      description:
        "We focus on delivering cutting-edge, innovative, & tailored solutions.",
    },
  ],
  nameField: {
    placeholder: "Your Name",
    label: "Your Name",
  },
  emailField: {
    placeholder: "Enter Email",
    label: "Enter Your Email",
  },
  phoneField: {
    placeholder: "Enter Phone Number",
    label: "Enter Phone Number",
  },
  companyField: {
    placeholder: "Enter Company Name",
    label: "Enter Company Name",
  },
  projectDetailsField: {
    placeholder: "Project Details",
    label: "Project Details",
  },

  submit: "Submit",
  loading: "Loading...",
};
